<div class="padding">
  @if (dataLoading()) {
    <app-loading-animation></app-loading-animation>
  }

  @if (dataAvailable()) {
    <div>
      <div class="invoice-summary-container">
        <app-table-template tableTitle="Invoice Summary"
          tableTitleId="invoice-summary-title"
          [showTitle]="true"
          [showSearch]="false"
          [showToggle]="false"
          [hasCardView]="true"
          [showPagination]="false"
          [clickableRows]="false"
          [columns]="columns()"
          [currentPage]="currentPage()"
          [sortedOn]="sortField()"
          [sortDescending]="sortOrder() === -1"
          [tableMinWidthInRem]="80"
          (sortChanged)="sort($event)">
          <app-invoice-summary-card-container [currentPage]="currentPage()" [clickableRows]="false"></app-invoice-summary-card-container>
        </app-table-template>
      </div>
      <div class="invoice-details-container">
        <app-view-invoice-details
          class="temp"
          [clientCode]="entityId()"
          [padding]="false"
        ></app-view-invoice-details>
      </div>
    </div>
  }

  @if (dataEmpty()) {
    <div class="empty">No invoices available</div>
  }
</div>
